<template>
    <client-page class="app--main">
        <template v-if="isMain">
            <lecture-main />
        </template>
        <template v-else>
            <lecture-list
                v-bind="{
                    category,
                    isStream,
                    isMiceNow,
                }"
            />
        </template>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import LectureMain from "@/components/client/lectures/main/lecture-main.vue";
import LectureList from "@/components/client/lectures/list/lecture-list.vue";
import { mapActions } from "vuex";

export default {
    components: {
        ClientPage,
        LectureMain,
        LectureList,
    },
    computed: {
        category() {
            return this.$store.state.lecture.category.items.find(({ code }) => code == this.$route.query.category);
        },
        isStream() {
            return this.$route.query.isStream;
        },
        isMiceNow() {
            return this.$route.query.isMiceNow;
        },
        isMain() {
            return !this.category && !this.isStream && !this.isMiceNow;
        },
    },
    methods: {
        ...mapActions("lecture/category", {
            getCategories: "getItems",
        }),
        init() {
            this.getCategories();
        },
    },
    mounted() {
        this.init();
    },
};
</script>
